module.exports = __webpack_public_path__ + "img/carbon-chart-v2.2179553b.png";